import { baseUrl } from './routes';

export class TicketsRoutes {
  static get tickets(): string {
    return `${baseUrl}/tickets`;
  }

  static get list(): string {
    return `${baseUrl}/tickets/list`;
  }

  static get add(): string {
    return `${baseUrl}/tickets/add`;
  }

  static get edit(): string {
    return `${baseUrl}/tickets/edit`;
  }

  static get view(): string {
    return `${baseUrl}/tickets/view`;
  }

  static get myTickets(): string {
    return `${baseUrl}/tickets/my-tickets`;
  }
}
